import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./components/AuthContext";

import Navbar from "./components/Navbar";
import PrivateRoute from "./components/PrivateRoute";

import CarsafSevkiyat from "./pages/CarsafSevkiyat";
import ZoneYukle from "./pages/ZoneYukle";
import CarsafPompa from "./pages/CarsafPompa";
import SevkiyatDuzletme from "./pages/SevkiyatDuzletme";
import HazirBetonRapor from "./pages/HazirBetonRapor";
import AracPuantajPage from "./pages/AracPuantajPage";


const HazirBetonRoutes = () => {
  const { user, role, loading } = useAuth();

  if (loading) return <div className="text-center mt-10">Yükleniyor...</div>;
  if (!user || !role) return <Navigate to="/giris" replace />;

  const getDefaultRoute = () => "carsaf-sevkiyat";

  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Navigate to={getDefaultRoute()} replace />} />

        <Route
          path="carsaf-sevkiyat"
          element={
            <PrivateRoute>
              <CarsafSevkiyat />
            </PrivateRoute>
          }
        />

        <Route
          path="zone-yukle"
          element={
            <PrivateRoute>
              <ZoneYukle />
            </PrivateRoute>
          }
        />

        <Route
          path="carsaf-pompa"
          element={
            <PrivateRoute>
              <CarsafPompa />
            </PrivateRoute>
          }
        />

        <Route
          path="sevkiyat-duzelt"
          element={
            <PrivateRoute>
              <SevkiyatDuzletme />
            </PrivateRoute>
          }
        />

        <Route
          path="hazirbeton-rapor"
          element={
            <PrivateRoute>
              <HazirBetonRapor />
            </PrivateRoute>
          }
        />

        <Route
          path="puantaj"
          element={
            <PrivateRoute>
              <AracPuantajPage />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<Navigate to={getDefaultRoute()} replace />} />
      </Routes>
    </>
  );
};

const Main = () => (
  <AuthProvider>
    <HazirBetonRoutes />
  </AuthProvider>
);

export default Main;
